import type {ServerError} from '../../ServerError'

import type {CSRFErrorResponse, CSRFResponse} from './types'

/**
 * Проверяет, является ли ошибка связанной с недействительным CSRF-токеном.
 *
 * @param {ServerError<CSRFErrorResponse>} error - Объект ошибки, содержащий тело ответа с кодом ошибки.
 * @return {boolean} Возвращает true, если код ошибки равен "INVALID_CSRF_TOKEN", иначе false.
 */
function isInvalidCsrfToken(error: ServerError<CSRFErrorResponse>): boolean {
  const bodyCode = error.body?.code
  return bodyCode === "INVALID_CSRF_TOKEN"
}

/**
 * Проверяет, является ли переданный ответ CSRF-ответом.
 *
 * @param response - Ответ, который необходимо проверить.
 * @return - Возвращает true, если ответ является объектом CSRFResponse, иначе false.
 */
function isCsrfResponse (response: unknown): response is CSRFResponse {
  if (response === null) {
    return false
  }

  if (typeof response === "object") {
    return 'max-age-seconds' in response && 'sk' in response
  }

  return false
}

export {isInvalidCsrfToken, isCsrfResponse}
